import { render } from "./articleTemplate.vue?vue&type=template&id=76c8d4f7&scoped=true&lang=html"
import script from "./articleTemplate.vue?vue&type=script&lang=js"
export * from "./articleTemplate.vue?vue&type=script&lang=js"

import "./articleTemplate.vue?vue&type=style&index=0&id=76c8d4f7&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76c8d4f7"]])

export default __exports__